import { render, staticRenderFns } from "./InvPD_Items.vue?vue&type=template&id=ec20ae6e"
import script from "./InvPD_Items.vue?vue&type=script&lang=js"
export * from "./InvPD_Items.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports